export const ZERO_ADDRESS: string = '0x0000000000000000000000000000000000000000';
export const DEAD_ADDRESS: string = '0x000000000000000000000000000000000000dEaD'
export const MAX_UINT: string = "115792089237316195423570985008687907853269984665640564039457584007913129639935";